// extracted by mini-css-extract-plugin
export var container__img = "FeaturedTermo-module--container__img--93a10";
export var container__title = "FeaturedTermo-module--container__title--18154";
export var img1 = "FeaturedTermo-module--img1--14eee";
export var img2 = "FeaturedTermo-module--img2--354d9";
export var img3 = "FeaturedTermo-module--img3--d4fad";
export var img__container = "FeaturedTermo-module--img__container--65b3c";